import React, {useEffect, useReducer} from 'react';
import {Account, AccountContextType, initialAccountContextType} from "./types";
import {removeAccount, selectAccount, setAccountError} from "./actions";
import {accountService} from "../../services/account/AccountService";
import {ErrorResponse} from "../../hooks/fetch/types";
import {accountReducer, initialAccountState} from "./AccountReducer";

export const AccountContext = React.createContext<AccountContextType>(initialAccountContextType);

const AccountProvider: React.FC<{ children: React.ReactNode }> = ({children}) => {
    const [account, dispatch] = useReducer(accountReducer(), initialAccountState);

    useEffect(() => {
        getAccount()
    }, []);

    const getAccount = () => {
        accountService.getAccount()
            .then((account) => {
                dispatch(selectAccount(account))
            })
            .catch(() => {
                // Initial load - no account saved yet is not an error to display
            })
    };

    const deleteAccount = () => {
        accountService.remove()
            .then(() => {
                dispatch(removeAccount());
            })
            .catch((error: ErrorResponse) => {
                const message = error.message || error.statusText || 'Failed to remove account';
                dispatch(setAccountError(message));
            })
    }

    const create = (account: Account) => {
        accountService.save(account)
            .then(() => {
                dispatch(selectAccount(account));
            })
            .catch((error: ErrorResponse) => {
                const message = error.message || error.statusText || 'Failed to save account';
                dispatch(setAccountError(message));
            })
    }

    return (
        <AccountContext.Provider value={{data: account.data, error: account.error, createAccount: create, removeAccount: deleteAccount}}>
            {children}
        </AccountContext.Provider>
    );
};

export default AccountProvider;